// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"e5f88200","164":"d02252bc","260":"443215cb","332":"5a69712a","393":"1e2c3f1d","407":"c74bf5a9","470":"21c15cf0","590":"9637a6f7","629":"52abb821","642":"1ea7a0f6","657":"1ad57a67","659":"f978e660","696":"5194f28a","754":"c217d35e","955":"66bf94f8"}[chunkId] + ".chunk.js";
};